import React from 'react';
import { useSystemTradingPlatforms } from '../hooks/use-system-trading-platforms.js';
import SystemTradingPlatformsPageView from './system-trading-platforms-page-view.jsx';

function SystemTradingPlatformsPageContainer() {
  const state = useSystemTradingPlatforms();
  return <SystemTradingPlatformsPageView {...state} />;
}

export default SystemTradingPlatformsPageContainer;

